import React from "react";
import { useState } from "react";
import { Routes, Link, Route } from "react-router-dom";
import Home from "../../../pages/Home/Home";
import Services from "../../../pages/Services/Services";
import About from "../../../pages/About/About";
// import { motion } from "framer-motion";
export default function Navbar() {
  const links = [
    { name: "Home", link: "/" },
    { name: "Service", link: "/services" },
    { name: "About", link: "/about" },
  ];

  let [open, setOpen] = useState(false);
  return (
    <>
      {/* parent div */}
      <div className=" item-center left-0 top-0 flex w-full justify-center">
        {/* child div */}
        <div className="  bg-primary-irisBlue px-7   md:px-10 md:py-4 ">
          {/* logo div */}
          {/* <div className="item-center font-san flex cursor-pointer text-2xl font-bold text-white font-spartan">
            <span className="mr-1 pt-2 text-3xl text-primary-blue">
              <ion-icon name="logo-soundcloud"></ion-icon>
            </span>
            cleaner
          </div> */}

          {/* mobile div menu button */}
          <div
            onClick={() => setOpen(!open)}
            className="relative -bottom-5 left-44 p-2 text-3xl  sm:hidden shadow-2xl bg-primary-venderMint rounded-md justify-center flex items-center "
          >
            <ion-icon name={open ? "close" : "menu"}></ion-icon>
          </div>
          <ul
            className={`absolute left-0 w-full rounded-b-xl bg-primary-irisBlue bg-opacity-95  pl-9 transition-all duration-500 ease-in-out md:static md:z-auto
                    md:flex md:w-auto md:items-center md:pb-0 md:pl-0 ${
                      open ? "top-16" : "-top-96"
                    }`}
          >
            {links.map((link) => (
              <li key={link.name} className="my-7 text-3xl md:my-0 md:ml-8">
                <Link to={link.link}>
                  <a
                    href={link.link}
                    className="rounded-lg bg-primary-blue p-2 font-spartan 
                            text-primary-lightCyan duration-700 ease-in-out  hover:translate-y-3 md:hover:bg-primary-venderMint md:hover:text-primary-black hover:shadow-xl"
                  >
                    {link.name}
                  </a>
                </Link>
              </li>
            ))}

            {/* <Button></Button> */}
          </ul>
        </div>
      </div>
      {/* define the routes */}
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route path="/services" element={<Services />}></Route>
        <Route path="/about" element={<About />}></Route>
      </Routes>
    </>
  );
}
